import React, { FC } from 'react';
import { Typography } from 'design_system/src';
import { ReactComponent as Reload } from 'design_system/src/static/icons/reload-square.svg';
import { momentLocal } from 'models/shared/helpers/dates';
import {
	ConversationResponderEnum,
	ConversationResponderValues,
	ResponderHistoric,
} from 'models/conversation/interfaces/conversation.interface';
import '../statusHistory/history.scss';

interface ResponderHistoryProps {
	historic?: ResponderHistoric[];
}

const ResponderHistory: FC<ResponderHistoryProps> = ({ historic }) => {
	const display = [...(historic ?? [])].reverse();

	return (
		<div className="flex_body historic_status">
			<Typography scale="medium" weight="600" className="m_b_xs">
				Historial de &quot;quién responde&quot;
			</Typography>
			{display.map((change, i) => {
				const previous = display[i + 1];
				return (
					<div
						className="p_y_lg historic_change bg_neutral_100 p_x_md"
						key={`${change.updatedAt}-${change.responder}`}
					>
						<div className="display_flex flex_justify_between m_b_md">
							<Typography scale="xsmall" weight="600" textColor="neutral_600">
								{change.by?.name ?? 'Sistema'}
							</Typography>
							<div className="display_flex flex_gap_xxxs flex_align_center">
								{previous ? (
									<>
										<Typography
											scale="xsmall"
											weight="600"
											className="p_x_md p_y_xxs br_xs text_center text_neutral_0 pos_relative bg_neutral_300"
										>
											{
												ConversationResponderValues[
													previous.responder as ConversationResponderEnum
												]
											}
										</Typography>
										<Reload className="dim_md text_neutral_800" />
									</>
								) : null}
								<Typography
									scale="xsmall"
									weight="600"
									className="p_x_md p_y_xxs br_xs text_center text_neutral_0 pos_relative bg_primary_300"
								>
									{
										ConversationResponderValues[
											change.responder as ConversationResponderEnum
										]
									}
								</Typography>
							</div>
						</div>
						<Typography scale="xsmall" weight="400">
							Fecha de modificación:{' '}
							<Typography scale="small" weight="400" component="span">
								{momentLocal(change.updatedAt).format('YYYY-MM-DD HH:mm')}
							</Typography>
						</Typography>
					</div>
				);
			})}
		</div>
	);
};

export default ResponderHistory;
